import React,{useEffect, useState}from 'react'
import { message, List, } from 'antd';
import { useBnsMeiJieWenDangDelMutation, useBnsMeiJieWenDangListQuery } from '../../store/ReactWebSiteApi';
import ModalDel from '../../cpn/ModalDel';
import DocCheck from './DocCheck';
import DocAdd from './DocAdd';

function DocList(props) {       
    const [list, setList] = useState([]); 
    const {data, isSuccess} = useBnsMeiJieWenDangListQuery({
        bmjwd_bmj_id:props.bmj_id
    });    
    useEffect(() => {
        if (isSuccess) {
            console.log(data);
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {bmjwd_id:key,bmjwd_name,bmjwd_ctime,bmjwd_cname,bmjwd_jihua,bmjwd_xuzhi,bmjwd_id,bg_name,bg_id} = item;
                    return item = {key,bmjwd_name,bmjwd_ctime,bmjwd_cname,bmjwd_jihua,bmjwd_xuzhi,bmjwd_id,bg_name,bg_id}
                })                
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.bmjwd_ctime;
                    let bTimeString = b.bmjwd_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)                
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])   

    //删除
    const [del] = useBnsMeiJieWenDangDelMutation()
    return (
        <>  
            {list && <List>
                {list.map((item) => {
                    return  <List.Item
                                key={item.key}
                                actions={[<ModalDel onOk={() => {
                                    del({bmjwd_id:item.bmjwd_id}).then((res) => {
                                        console.log(res);
                                        if (res.data.Status === 'success') {
                                            message.success('删除成功！')                                                                              
                                        }
                                        if (res.data.Status === 'fail') {
                                            message.error('删除失败！'+res.data.Message)
                                        }
                                    })
                                }} /> ]}
                            >
                                <DocCheck                 
                                    bmjwd_name={item.bmjwd_name}                                   
                                    bmjwd_id={item.key}                                    
                                    bmj_name={props.bmj_name}                                    
                                    bmj_id={props.bmj_id}                                    
                                />
                            </List.Item>
                })}
            </List>}         
            <div>
                <DocAdd
                    bmj_dept_id={props.bmj_dept_id}
                    bmj_dept_name={props.bmj_dept_name}
                    bmj_id={props.bmj_id}
                />                
            </div>   
        </>
    )
}

export default DocList